/**
 * Поле «файл или ссылка».
 *
 * Партнёру всё равно, где лежит файл: он хочет приложить фото со склада или
 * вставить ссылку на ролик. Поэтому одно поле делает оба: вставил ссылку —
 * сохранили ссылку, выбрал файл — загрузили и подставили адрес.
 */
import { ApiError } from '@allswipes/client';
import { Button } from '@allswipes/ui';
import { useRef, useState } from 'react';

import { api } from '../api';
import { useToast } from '../toast';

export function MediaField({
  value,
  onChange,
  accept,
  placeholder,
  upload: canUpload = true,
}: {
  value: string;
  onChange: (url: string) => void;
  accept: string;
  placeholder?: string;
  /** Загрузка файлом выключена платформой — остаётся только ссылка. */
  upload?: boolean;
}) {
  const toast = useToast();
  const input = useRef<HTMLInputElement>(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file: File | undefined) => {
    if (!file) return;
    setBusy(true);
    try {
      onChange(await api.uploadMedia(file));
      toast('Файл загружен');
    } catch (err) {
      toast(err instanceof ApiError ? err.message : 'Не получилось загрузить');
    } finally {
      setBusy(false);
      if (input.current) input.current.value = '';
    }
  };

  return (
    <>
      <div className="row" style={{ gap: 8 }}>
        <input
          className="input mono"
          style={{ flex: 1, minWidth: 0 }}
          value={value}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
        />
        {canUpload && (
          <>
            <Button size="sm" icon="upload" disabled={busy} onClick={() => input.current?.click()}>
              {busy ? 'Гружу…' : 'Файл'}
            </Button>
            <input
              ref={input}
              type="file"
              accept={accept}
              hidden
              onChange={(e) => void upload(e.target.files?.[0])}
            />
          </>
        )}
      </div>

      {value && isImage(value) && (
        <img
          src={value}
          alt=""
          style={{
            marginTop: 8,
            maxHeight: 160,
            borderRadius: 10,
            border: '1px solid var(--border)',
            display: 'block',
          }}
        />
      )}
    </>
  );
}

function isImage(url: string): boolean {
  return /\.(jpe?g|png|webp)(\?|$)/i.test(url);
}
